<template>
     <b-col lg="6" md="6">
        <div class="foto-input-wrapper">
            <div class="foto-preview-wrapper">
                <div class="foto-content-wrapper">
                    <img :src="fotoTipe.name" alt="Foto Identitas">
                    <div class="foto-view-wrapper">
                        <b-button></b-button>
                        <!-- <b-button @click="openModalPreview(1)">View</b-button> -->
                    </div>
                </div>
                <!-- <h6 v-else class="text-blue">No Photo</h6> -->
            </div>
            <!-- <div class="foto-action-wrapper">
                <div class="action-browse-wrapper">
                    <b-form-file
                        v-model="dataFoto.fotoIdentitas" name="fotoIdentitas"
                        :state="Boolean(dataFoto.fotoIdentitas)"
                        placeholder="Foto Identitas"
                        drop-placeholder="Drop file here..."
                        accept=".jpg, .png, .jpeg"
                        @input="browseFile(1)"
                    ></b-form-file>
                    <b-button variant="cancelBtn">
                        <i class="fa fa-upload mr-2"></i>
                        Browse
                    </b-button>
                </div>
                <div class="action-camera-wrapper cameraSmallWrapper">
                    <b-button variant="pgiBtn" class="foto-cam-btn" name="fotoViaCameraBtn" @click="ambilFoto(1)">
                        <i class="fa fa-camera mr-2"></i>
                        Camera
                    </b-button>
                </div>
                <div class="action-reset-wrapper" v-if="dataFoto.urlFotoIdentitas != null && dataFoto.activeFotoIdentitasBase64 != $baseFilePath + dataFoto.urlFotoIdentitas">
                    <b-button variant="cancelBtn" @click="resetFoto(1)">
                        <i class="fa fa-undo mr-2"></i>
                        Reset
                    </b-button>
                </div>
            </div> -->
        </div>
    </b-col>
</template>

<script>

export default {
    name: 'foto-pendukung',
    props: {
        fotoTipe: { type: Object, required: true },
        // length: { type: Number, required: true },
        // minLength: { type: Number, required: true },
    },
    methods: {
       
    }
}
</script>